 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TITLEPAGE from '@/components/titlepage'
 import OEBPSCOVERIMAGE from '@/components/OEBPS/CoverImage'
 import OEBPSLOVESICKGODS_EBOOK1_01 from '@/components/OEBPS/LovesickGods_eBook1_01'
 import OEBPSLOVESICKGODS_EBOOK1_011 from '@/components/OEBPS/LovesickGods_eBook1_011'
 import OEBPSLOVESICKGODS_EBOOK1_012 from '@/components/OEBPS/LovesickGods_eBook1_012'
 import OEBPSLOVESICKGODS_EBOOK1_013 from '@/components/OEBPS/LovesickGods_eBook1_013'
 import OEBPSLOVESICKGODS_EBOOK1_014 from '@/components/OEBPS/LovesickGods_eBook1_014'
 import OEBPSLOVESICKGODS_EBOOK1_015 from '@/components/OEBPS/LovesickGods_eBook1_015'
 import OEBPSLOVESICKGODS_EBOOK1_016 from '@/components/OEBPS/LovesickGods_eBook1_016'
 import OEBPSLOVESICKGODS_EBOOK1_017 from '@/components/OEBPS/LovesickGods_eBook1_017'
 import OEBPSLOVESICKGODS_EBOOK1_018 from '@/components/OEBPS/LovesickGods_eBook1_018'
 import OEBPSLOVESICKGODS_EBOOK1_019 from '@/components/OEBPS/LovesickGods_eBook1_019'
 import OEBPSLOVESICKGODS_EBOOK1_0110 from '@/components/OEBPS/LovesickGods_eBook1_0110'
 import OEBPSLOVESICKGODS_EBOOK1_0111 from '@/components/OEBPS/LovesickGods_eBook1_0111'
 import OEBPSLOVESICKGODS_EBOOK1_0112 from '@/components/OEBPS/LovesickGods_eBook1_0112'
 import OEBPSLOVESICKGODS_EBOOK1_0113 from '@/components/OEBPS/LovesickGods_eBook1_0113'
 import OEBPSLOVESICKGODS_EBOOK1_0114 from '@/components/OEBPS/LovesickGods_eBook1_0114'
 import OEBPSLOVESICKGODS_EBOOK1_0115 from '@/components/OEBPS/LovesickGods_eBook1_0115'
 import OEBPSLOVESICKGODS_EBOOK1_0116 from '@/components/OEBPS/LovesickGods_eBook1_0116'
 import OEBPSLOVESICKGODS_EBOOK1_0117 from '@/components/OEBPS/LovesickGods_eBook1_0117'
 import OEBPSLOVESICKGODS_EBOOK1_0118 from '@/components/OEBPS/LovesickGods_eBook1_0118'
 import OEBPSLOVESICKGODS_EBOOK1_0119 from '@/components/OEBPS/LovesickGods_eBook1_0119'
 import OEBPSLOVESICKGODS_EBOOK1_0120 from '@/components/OEBPS/LovesickGods_eBook1_0120'
 import OEBPSLOVESICKGODS_EBOOK1_0121 from '@/components/OEBPS/LovesickGods_eBook1_0121'
 import OEBPSLOVESICKGODS_EBOOK1_0122 from '@/components/OEBPS/LovesickGods_eBook1_0122'
 import OEBPSLOVESICKGODS_EBOOK1_0123 from '@/components/OEBPS/LovesickGods_eBook1_0123'
 import OEBPSLOVESICKGODS_EBOOK1_0124 from '@/components/OEBPS/LovesickGods_eBook1_0124'
 import OEBPSLOVESICKGODS_EBOOK1_0125 from '@/components/OEBPS/LovesickGods_eBook1_0125'
 import OEBPSLOVESICKGODS_EBOOK1_0126 from '@/components/OEBPS/LovesickGods_eBook1_0126'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/titlepage",
 			"name" : "titlepage",
 			"component" : TITLEPAGE
 		},
 		{
 			"path" : "/OEBPS/CoverImage",
 			"name" : "OEBPS/CoverImage",
 			"component" : OEBPSCOVERIMAGE
 		},
 		{
 			"path" : "/OEBPS/LovesickGods_eBook1_01",
 			"name" : "OEBPS/LovesickGods_eBook1_01",
 			"component" : OEBPSLOVESICKGODS_EBOOK1_01
 		},
 		{
 			"path" : "/OEBPS/LovesickGods_eBook1_011",
 			"name" : "OEBPS/LovesickGods_eBook1_011",
 			"component" : OEBPSLOVESICKGODS_EBOOK1_011
 		},
 		{
 			"path" : "/OEBPS/LovesickGods_eBook1_012",
 			"name" : "OEBPS/LovesickGods_eBook1_012",
 			"component" : OEBPSLOVESICKGODS_EBOOK1_012
 		},
 		{
 			"path" : "/OEBPS/LovesickGods_eBook1_013",
 			"name" : "OEBPS/LovesickGods_eBook1_013",
 			"component" : OEBPSLOVESICKGODS_EBOOK1_013
 		},
 		{
 			"path" : "/OEBPS/LovesickGods_eBook1_014",
 			"name" : "OEBPS/LovesickGods_eBook1_014",
 			"component" : OEBPSLOVESICKGODS_EBOOK1_014
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js